import {combineReducers} from 'redux'
import update from 'immutability-helper' //React immutability helper
//Should I introduce initialization of user activity for quiz?
// SHOW_VIDEO, HIDE_VIDEO
import {REQUEST_QUIZ, RECEIVED_QUIZ,NOTRECEIVED_QUIZ,RESET_QUIZ, SETUP_QUIZ, SELECT_NEXT, SELECT_BEFORE, SELECT_CHECK, SELECT_CHOICE,PLAY_VIDEO } from '../actions/ActionTypes'
//  , UPDATE_LOCATION
import { routerReducer } from 'react-router-redux'

function fetchquiz_reducer(state={isFetching:false, issuccessful:false, quizQueue:[]}, action){
  switch (action.type) {
    case REQUEST_QUIZ:
      return update(state,{
        isFetching: {$set:true},
      })
    case RECEIVED_QUIZ: //It will generate state for quiz
      return update(state,{
        isFetching: {$set:false},
        issuccessful:{$set:true},
        quizQueue:{$push:[action.payload.quizID, action.payload.receivedAt]}
      })
    case NOTRECEIVED_QUIZ:
      return update(state,{
        isFetching: {$set:false},
        issuccessful:{$set:false}
      })
    default:
      return state
  }
}
// A simple function which return immutable array of size n.
function immutablearray(size, element){//size >=1
  if(size === 1) return [ element ]
  else return [...immutablearray(size-1,element), element]
}
export function handlequiz_reducer(state ={isquizready:false}, action) {
  switch (action.type) {
    case RESET_QUIZ:
      return update(state,
      {
         isquizready:{$set:false}
      })
    case SETUP_QUIZ: //It will generate state for quiz
      const result=immutablearray(action.payload.data.length,{correct:null, select:null,play:null})
      return update(state, 
      {
          data: {$set:action.payload.data},
          result:{$set: result},
          isquizready:{$set:true},
          lastUpdated:{$set: action.payload.receivedAt}
      })
    // We do not use SELECT_NEXT and SELECT_BEFORE since qnum is in routing.  
    case SELECT_NEXT:
      return update(state,{
        qnum:{$set: action.payload.qnum+1 < state.data.length?action.payload.qnum+1 :action.payload.qnum+1-state.data.length } 
      })
    case SELECT_BEFORE:
      return update(state,{
        qnum:{$set: action.payload.qnum+1 < state.data.length?action.payload.qnum-1 :action.payload.qnum-1+state.data.length }  
      })
    case SELECT_CHECK:
      const {correct,select }=state.result[action.payload.qnum]
      const { ans }=state.data[action.payload.qnum]
      if(correct===null){// Not yet evaluated
        var newcorrect= (select === ans ) ? true:false;
        return update(state,{
          result: { [action.payload.qnum]: {correct : {$set: newcorrect }}}
        })
      }
      else{
        return state;
      }
    case SELECT_CHOICE:
      //console.log('Reducer:SELCT_CHOICE')
      return (
        update(state,{
          result:{
            [action.payload.qnum]:{
              select:{$set:action.payload.cID}
            }
          } 
        })
      )
    case PLAY_VIDEO:
      //console.log('Reducer:PLAY_VIDEO')
      const { play }=state.result[action.payload.qnum];
      if(play===null){// Not yet evaluated
        return update(state,{
          result: { [action.payload.qnum]: {play : {$set: true }}}
        })
      }
      else{
        return state;
      }
    /*  
    case SHOW_VIDEO:
      return state.map(todo =>
        todo.id === action.payload.id ?
          //?:
          todo
      )
    case HIDE_VIDEO:
      return state.map(todo =>
        todo.id === action.payload.id ?
         //?:
          todo
      )
    */
    default:
      return state
  }
}
const quizReducer= combineReducers({
  fetch: fetchquiz_reducer,
  quiz: handlequiz_reducer,
  routing: routerReducer
})

export default quizReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js